var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Sfumatura_senza_nome_13823);\n      }\n\n      .st1 {\n        fill: url(#Sfumatura_senza_nome_1382);\n      }\n\n      .st2 {\n        fill: url(#Sfumatura_senza_nome_13831);\n      }\n\n      .st3 {\n        fill: url(#Sfumatura_senza_nome_13821);\n      }\n\n      .st4 {\n        fill: url(#Sfumatura_senza_nome_1383);\n      }\n\n      .st5 {\n        fill: url(#Sfumatura_senza_nome_13822);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1382",
    "data-name": "Sfumatura senza nome 1382",
    x1: 43.5,
    y1: 11.45,
    x2: 44.78,
    y2: 34.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ebebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2db7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2da3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2d839d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2d5783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d4b7c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_1383",
    "data-name": "Sfumatura senza nome 1383",
    x1: 32.82,
    y1: 45.98,
    x2: 52.02,
    y2: 31.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d4b7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2d5783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2d839d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#2da3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2db7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebebf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_13821",
    "data-name": "Sfumatura senza nome 1382",
    x1: 32.04,
    y1: 46.9,
    x2: 19.46,
    y2: 41.96,
    xlinkHref: "#Sfumatura_senza_nome_1382"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_13822",
    "data-name": "Sfumatura senza nome 1382",
    x1: 17.48,
    y1: 37.02,
    x2: 11.35,
    y2: 24.78,
    xlinkHref: "#Sfumatura_senza_nome_1382"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_13823",
    "data-name": "Sfumatura senza nome 1382",
    x1: 8.64,
    y1: 25.36,
    x2: 26.28,
    y2: 13.5,
    xlinkHref: "#Sfumatura_senza_nome_1382"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_13831",
    "data-name": "Sfumatura senza nome 1383",
    x1: 44.04,
    y1: 20.54,
    x2: 21.43,
    y2: 8.01,
    xlinkHref: "#Sfumatura_senza_nome_1383"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.61,44.15c.88-.51,1.43-1.44,1.43-2.46v-23.99c0-1.01-.54-1.95-1.43-2.46l-13.53-7.77c3.7,2.13,4.36,5.13,4.53,10.37v11.85c0,3.39-1.3,6.78-3.9,9.36-.84.84-1.77,1.54-2.76,2.1l5.21,8.98,10.44-6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.88,56.14c.88.51,1.97.51,2.85,0l20.88-11.99c.88-.51,1.43-1.44,1.43-2.46v-15.55c0,4.25-2.28,6.32-6.76,9.09l-10.32,5.93c-2.95,1.69-6.55,2.27-10.1,1.32-1.15-.31-2.22-.76-3.21-1.32l-5.21,8.98,10.44,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.57,41.69c0,1.01.54,1.95,1.43,2.46l20.88,11.99c.88.51,1.97.51,2.85,0l13.53-7.77c-3.7,2.13-6.64,1.19-11.3-1.28l-10.32-5.93c-2.95-1.69-5.25-4.51-6.2-8.04-.31-1.15-.45-2.3-.45-3.43H5.57v11.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7,15.24c-.88.51-1.43,1.44-1.43,2.46v23.99c0,1.01.54,1.95,1.43,2.46l13.53,7.77c-3.7-2.13-4.36-5.13-4.53-10.38v-11.85c0-3.39,1.3-6.78,3.9-9.36.84-.84,1.77-1.54,2.76-2.1l-5.21-8.98-10.44,6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.73,3.25c-.88-.51-1.97-.51-2.85,0L7,15.24c-.88.51-1.43,1.44-1.43,2.46v15.55c0-4.25,2.28-6.32,6.76-9.09l10.32-5.93c2.95-1.69,6.55-2.27,10.1-1.32,1.15.31,2.22.76,3.21,1.32l2.12-10.76-7.35-4.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.16,26.27c.31,1.14.45,2.28.45,3.4v-11.83c-.17-5.25-.83-8.25-4.53-10.37l-7.35-4.22c-.88-.51-1.97-.51-2.85,0l-13.53,7.77c3.7-2.13,6.64-1.19,11.3,1.28l10.32,5.93c2.95,1.69,5.25,4.51,6.2,8.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/CRM.5962e281fad21ba3e318e06ed34d7e48.svg";
export { ForwardRef as ReactComponent };